import React, { ReactNode } from "react";

import { WindDegreeIcon } from "./WindDegreeIcon";

import { Spacer } from "@/components/common";
import { Weather } from "@/models/weather";

type Props = {
  weather: Weather;
  color?: "white" | "gray";
  label: string | ReactNode;
};

export const WindDegreeIconWithLabel = ({ weather, color, label }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <WindDegreeIcon weather={weather} color={color} />
      <Spacer y="4px" />
      <span className="text-[1.1rem] leading-none">{label}</span>
    </div>
  );
};
